import React, { FC } from 'react';
import { useAuthContext } from '@raisin/cp-layout';
import { getDistributor } from '@raisin/cp-utils';
import {
  ClickableCards as ClickableCardsComponent,
  ClickableCardsProps,
} from '@raisin/components-lib';
import { onTrackClickableCardsClicked } from 'eventsTracking';

export const ClickableCards: FC<Omit<ClickableCardsProps, 'onCtaClicked'>> = (props) => {
  const { isLoggedIn } = useAuthContext();

  const onCtaClick = (id: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    const card = props.cards.find(
      (item) => item?.button?.inner_page?.at(0)?.uid === id || item?._metadata.uid === id,
    );

    if (!card) {
      return;
    }

    const targetUrl = card.button?.inner_page?.at(0)?.url || card?.button?.external_url;

    if (!targetUrl) {
      return;
    }

    return onTrackClickableCardsClicked({
      distributorId: getDistributor(),
      isLoggedIn,
      pageUrl: window.location.href,
      targetUrl,
      openInNewTab: card.button?.open_link_in_new_tab,
      card: id,
      event,
    });
  };

  return <ClickableCardsComponent {...props} onCtaClicked={onCtaClick} />;
};
